import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="loading-spinner"
export default class extends Controller {
  static targets = [ "wrapper" ]

  connect() {
    this.content = `
      <div id="loading-spinner" class="z-3 position-absolute start-0 top-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center">
        <div class="spinner-border text-white" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>`
  }

  show() {
    // this.wrapperTargetに新規div要素を追加
    if (this.wrapperTarget.querySelector("#loading-spinner")) return
    this.wrapperTarget.insertAdjacentHTML("beforeend", this.content)
  }
}
